import { combineReducers } from "redux";
import { Clinic } from "../types";
import { getSuccessActionType } from "../utils";
import { CHANGE_CLINIC_STATUS_REQUEST, FETCH_CLINIC_REQUEST, UPDATE_CLINIC_REQUEST } from "./constants";
import { Action } from "./types";

type ClinicItem = Partial<Clinic>;

function item(state: ClinicItem = {}, action: Action): ClinicItem {
  switch (action.type) {
    case getSuccessActionType(FETCH_CLINIC_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_CLINIC_REQUEST):
    case getSuccessActionType(CHANGE_CLINIC_STATUS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

export const clinic = combineReducers({ item });
